export const liscioCyan350 = '#00687A';
export const liscioGrey100 = '#E0E1E2';
export const liscioGrey50 = '#F9FAFB';
export const liscioBlueGrey400 = '#353C42';
export const liscioWhite = '#ffffff';
export const liscioTextDark = liscioBlueGrey400;